import { Chip, CHIP_SIZE, CHIP_TYPE } from '@repo/design-system/index'
import classNames from 'classnames'
import { useCafJobStatus, UserJobStatus } from '../../../modules/apis/student/lesson'
import { COLORS } from '../../../modules/vars'

const NewTag = ({ className, tipSection = false }: { className?: string; tipSection?: boolean }) => {
  const { data: jobStatus } = useCafJobStatus()

  if (!jobStatus) return null
  if (jobStatus === UserJobStatus.SHOW) return null
  else
    return (
      <div className={classNames('', className)}>
        <Chip type={CHIP_TYPE.ACTIONABLE} size={tipSection ? CHIP_SIZE.SM : CHIP_SIZE.XS} customBgColor={COLORS.RED50}>
          <Chip.Label customTxtColor={COLORS.RED400}>New</Chip.Label>
        </Chip>
      </div>
    )
}
export default NewTag
